import { MapPin, Phone, Mail } from "lucide-react";
import { CONTACT } from "@/data/content";

const MAP_SRC =
  "https://www.google.com/maps?q=Legionowa+28,+15-281+Bia%C5%82ystok&z=16&output=embed";

export default function OfficeMap() {
  return (
    <div
      data-testid="office-map"
      className="mt-10 rounded-2xl overflow-hidden border border-[var(--ikra-line)] bg-[var(--ikra-bg-deep)]"
    >
      <div className="relative aspect-[16/9] w-full">
        <iframe
          title="Biuro Ikra, Legionowa 28/608, Białystok"
          src={MAP_SRC}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
          className="absolute inset-0 w-full h-full border-0"
          style={{ filter: "grayscale(100%) invert(92%) hue-rotate(180deg) contrast(0.95)" }}
        />
      </div>
      <div className="p-5 flex flex-col gap-3 text-sm text-[var(--ikra-ink)]/85">
        <a
          href="https://www.google.com/maps/search/?api=1&query=Legionowa+28+Bia%C5%82ystok"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="office-address-link"
          className="flex items-start gap-3 ikra-link"
        >
          <MapPin size={16} className="mt-0.5 text-[var(--ikra-gold)] shrink-0" />
          <span>{CONTACT.address}</span>
        </a>
        <a href={CONTACT.phoneHref} className="flex items-center gap-3 ikra-link" data-testid="office-phone-link">
          <Phone size={16} className="text-[var(--ikra-gold)] shrink-0" />
          {CONTACT.phone}
        </a>
        <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 ikra-link" data-testid="office-email-link">
          <Mail size={16} className="text-[var(--ikra-gold)] shrink-0" />
          {CONTACT.email}
        </a>
      </div>
    </div>
  );
}
